import "react-circular-progressbar/dist/styles.css";

import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import { CircularProgressbar } from "react-circular-progressbar";

interface Props {
  progressbarLabel: string;
  progressbarValue: number;
}

class CircularProgress extends React.Component<Props & StyledComponentProps> {
  public render() {
    const { classes } = this.props;
    return (
      <>
        <div className={classes && classes.wrapper}>
          <CircularProgressbar
            circleRatio={2 / 3}
            className={classes && classes.progress}
            value={this.props.progressbarValue}
            strokeWidth={10}
            styles={{
              path: {
                stroke: "#002E5F",
                // not working in IE
                transition: "stroke-dashoffset 2s ease 0s",
              },
              text: {
                fill: "black",
                fontSize: "15px",
              },
              trail: {
                stroke: "#ddd",
              },
            }}
          />
        </div>
        <div className={classes && classes.text}>
          <Typography variant="h4">
            {" "}
            {Math.round(10 * this.props.progressbarValue) / 10}
            {"%"}
          </Typography>
          <Typography
            className={classes && classes.info}
            align="center"
            variant="h6"
          >
            {this.props.progressbarLabel}
          </Typography>
        </div>
      </>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  info: {
    marginTop: "58px",
  },
  progress: {
    height: "250px",
    margin: "auto",
  },
  text: {
    bottom: "155px",
    margin: "auto",
    position: "relative",
    textAlign: "center",
    width: "250px",
  },
  wrapper: {
    transform: "rotate(-120deg)",
  },
});

export default withStyles(styles)(CircularProgress);



// WEBPACK FOOTER //
// ./src/components/CircularProgressbar.tsx